__turbopack_context__.v({
  "feeContainer": "InscriptionActionSell-module__5tb62G__feeContainer",
  "feeText": "InscriptionActionSell-module__5tb62G__feeText",
  "icon": "InscriptionActionSell-module__5tb62G__icon",
  "loading": "InscriptionActionSell-module__5tb62G__loading",
  "root": "InscriptionActionSell-module__5tb62G__root",
  "transferIcon": "InscriptionActionSell-module__5tb62G__transferIcon",
});
